import React from 'react';

import { isNotUndefined } from '@utils/util';
import { ScoreLevels, ScoreMap } from './constants';
import { useTranslation } from '@ies/intl-react-plugin';
import cs from 'classnames';

const ScoreBoard: React.FC<{ selected: ScoreLevels | undefined; onClick: (level: ScoreLevels) => void }> = ({
    selected,
    onClick,
}) => {
    const { t } = useTranslation();

    return (
        <div className="article-score-wrapper">
            {Object.keys(ScoreMap).map(key => {
                const item = ScoreMap[Number(key) as ScoreLevels];
                const hasSelected = isNotUndefined(selected);
                const active = hasSelected && selected === Number(key);

                let url;

                // 没有选择任何一个评分
                if (!hasSelected) {
                    url = item.light;
                } else if (active) {
                    url = item.gif;
                } else {
                    url = item.grey;
                }

                return (
                    <div
                        className={cs('article-score-item', {
                            'article-score-item--active': active,
                        })}
                        onClick={() => onClick(Number(key))}
                        key={key}
                    >
                        <img src={url} alt="" />
                        <span>{t(item.text)}</span>
                    </div>
                );
            })}
        </div>
    );
};

export default ScoreBoard;
